import { parseFrontmatter, renderMarkdown, formatContentDate, parseImageFields, type ContentImage } from "./content";

export interface NewsPost extends ContentImage {
  slug: string;
  title: string;
  description: string;
  date: string; // ISO yyyy-mm-dd
  html: string;
  sourceName: string;
  sourceUrl: string;
}

// Same build-time-bundled pattern as ../lib/blog.ts, parallel content
// folder. News posts additionally require sourceName/sourceUrl frontmatter
// — every news post must attribute and link to the real event it covers.
const files = import.meta.glob("../content/news/*.md", {
  eager: true,
  query: "?raw",
  import: "default",
}) as Record<string, string>;

const posts: NewsPost[] = Object.entries(files)
  .map(([path, raw]) => {
    const slug = path.split("/").pop()!.replace(/\.md$/, "");
    const { meta, body } = parseFrontmatter(raw);
    return {
      slug,
      title: meta.title ?? slug,
      description: meta.description ?? "",
      date: meta.date ?? "",
      html: renderMarkdown(body),
      sourceName: meta.sourceName ?? "",
      sourceUrl: meta.sourceUrl ?? "",
      ...parseImageFields(meta),
    };
  })
  .sort((a, b) => (a.date < b.date ? 1 : -1));

export function getAllNews(): NewsPost[] {
  return posts;
}

export function getNewsBySlug(slug: string): NewsPost | undefined {
  return posts.find((p) => p.slug === slug);
}

export const formatNewsDate = formatContentDate;
